import React from "react";
import { useTranslation } from "react-i18next";
import { FiGlobe } from "react-icons/fi";
import "../i18n";

function BtnChangLang() {
  const { i18n } = useTranslation();

  const currentLang = i18n.language;

  const toggleLanguage = () => {
    const newLang = currentLang === "ar" ? "en" : "ar";
    i18n.changeLanguage(newLang);
  };

  return (
    <button
      type="button"
      onClick={toggleLanguage}
      className="btn w-100 d-flex align-items-center justify-content-center gap-2 rounded-3"
      style={{
        minHeight: "40px",
        backgroundColor: "#FFFFFF",
        border: "1px solid #EEE5E8",
        color: "#555",
        fontSize: "13px",
        fontWeight: 600,
        transition: "all .2s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = "#F9E9EE";
        e.currentTarget.style.color = "#B5183F";
        e.currentTarget.style.borderColor = "#E8C4CE";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = "#FFFFFF";
        e.currentTarget.style.color = "#555";
        e.currentTarget.style.borderColor = "#EEE5E8";
      }}
    >
      <FiGlobe
        size={17}
        style={{
          color: "#B5183F",
          flexShrink: 0,
        }}
      />

      <span>{currentLang === "ar" ? "English" : "العربية"}</span>
    </button>
  );
}

export default BtnChangLang;
